
import * as yup from 'yup'

export const SettingsPasswordValidationScheme = yup.object().shape({
  currentPassword: yup
    .string()
    .max(256, 'Password has a maximum of 256 characters'),
  password: yup
    .string()
    .max(256, 'Password has a maximum of 256 characters'),
  confirmPassword: yup
    .string()
    .when('password', {
      is: (password) => !!(password && password.length > 0),
      then: yup
        .string()
        .required('Please confirm your password')
        .oneOf([yup.ref('password')], 'Passwords do not match'),
      otherwise: yup.string().notRequired()
    })
})
